export default __webpack_public_path__ + "static/media/sec_llave_mano.87e58d5b.png";